// tslint:disable-next-line:no-any
const isObject = (obj: any) => typeof obj === 'object' && obj !== null;

// tslint:disable-next-line:no-any
export const objectEquals = (objA: Record<any, any>, objB: Record<any, any>) => {
  if (objA === objB) {
    return true;
  }

  if (!objA || !objB) {
    return false;
  }

  const aKeys = Object.keys(objA);
  const bKeys = Object.keys(objB);

  if (aKeys.length !== bKeys.length) {
    return false;
  }

  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < aKeys.length; i++) {
    const key = aKeys[i];

    if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
      if (isObject(objA[key]) && isObject(objB[key]) && objectEquals(objA[key], objB[key])) {
        continue;
      }

      return false;
    }
  }

  return true;
};
